var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{class:['dh-psy-cencored', { 'dh-psy-cencored--revealed': _vm.revealed }]},[_c('span',{staticStyle:{"position":"relative"}},[_vm._v(_vm._s(_vm.content))])])}
var staticRenderFns = []

export { render, staticRenderFns }